export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "filter": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filter"])},
        "result": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["result"])},
        "results": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["results"])},
        "for": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["for"])},
        "from": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["from"])},
        "to": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["to"])},
        "clear": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["clear"])},
        "open_content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Open Content"])},
        "color": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Color"])},
        "date": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Date"])}
      },
      "de": {
        "filter": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filter"])},
        "result": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Resultat"])},
        "results": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Resultate"])},
        "for": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["für"])},
        "from": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ab"])},
        "to": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["bis"])},
        "clear": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["entferne"])},
        "open_content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Open Content"])},
        "color": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Farbe"])},
        "date": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Datum"])}
      }
    }
  })
}
